import React, { useState, useEffect, useRef } from "react";

import {
  Button,
  Dialog,
  Grid,
  Icon,
  Typography,
  FormHelperText,
  TextField
} from "@material-ui/core";
// import Chip from '@material-ui/core/Chip';
// import { makeStyles } from '@material-ui/core/styles';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import addDonorIcon from "../../../../assets/img/addIcon.svg";
import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";
import DialogLoader from "../../../../components/Loader/DialogLoader";
import {
  InputBaseField, MultiSelectField, SelectField
} from "../../../../components/InputField/InputField";
import {
  Label,
  DraggableComponent,
} from "../../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../../Services/APIService";
import { withSnackbar } from "../../../../components/Message/Alert";
import useStyles from "./styles";
import RichTextEditor from "react-rte";
import {
  allowedAttachmentsImages
} from "../../../../../src/components/Common/Extensions";

// const useStyles1 = makeStyles((theme) => ({
//   root: {
//     width: 500,
//     '& > * + *': {
//       marginTop: theme.spacing(3),
//     },
//   },
// }));
function AddNewAddress({
  dialogOpenClose,
  editProgram,
  handleClose,
  handleSuccessClose,
  ...props
}) {
  const classes = useStyles();
  // const classes1 = useStyles1();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState(editProgram ? editProgram : {});
  const regex = /(<([^>]+)>)/gi;
  const regexSpaces = /((&nbsp;))*/gim;
  const [errorMessages, setErrorMessages] = useState({
    errorNote: false,
    errorEditorMaxValue: false,
  });
  const [EDITOR_CHAR_LENGTH, setEDITOR_CHAR_LENGTH] = useState(0);
  const { showMessage } = props;

  const handleChange = (e) => {

    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const [editorValue, setEditorValue] = useState(
    RichTextEditor.createValueFromString("", "html")
  );

  const commonAttachments = allowedAttachmentsImages();
  const [bannerImage, setBannerImage] = useState({ file: null, fileToSend: null, fileName: null });

  function uploadSingleFile(e) {
    if (e.target.files == null || e.target.files.length <= 0)
      return
    const name = e.target.files[0].name;
    const lastDot = name.lastIndexOf('.');
    const fileName = name.substring(0, lastDot);
    const ext = name.substring(lastDot + 1);
    switch (ext) {
      case commonAttachments[ext]:
        break;
      default:
        showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
        return;
    }
    setBannerImage({
      file: URL.createObjectURL(e.target.files[0]),
      fileToSend: e.target.files[0],
      fileName: e.target.files[0].name
    })

  }

  const [donorImage, setDonorImage] = useState({ file: null, fileToSend: null, fileName: null });
  function uploadDonorFile(e) {
    if (e.target.files == null || e.target.files.length <= 0)
      return
    const name = e.target.files[0].name;
    const lastDot = name.lastIndexOf('.');
    const fileName = name.substring(0, lastDot);
    const ext = name.substring(lastDot + 1);
    switch (ext) {
      case commonAttachments[ext]:
        break;
      default:
        showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
        return;
    }
    setDonorImage({
      file: URL.createObjectURL(e.target.files[0]),
      fileToSend: e.target.files[0],
      fileName: e.target.files[0].name
    })

  }

  const donorFile = useRef(null);

  const donFile = () => {

    donorFile.current.click();
  };

  const inputFile = useRef(null);

  const uploadFile = () => {

    inputFile.current.click();
  };

  const toolbarConfig = {
    display: [
      "INLINE_STYLE_BUTTONS",
      "BLOCK_TYPE_BUTTONS",
      "BLOCK_TYPE_DROPDOWN",
    ],
    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD", className: "custom-css-class" },
      { label: "Italic", style: "ITALIC" },
      { label: "strikethrough", style: "STRIKETHROUGH" },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: "UL", style: "unordered-list-item" },
      { label: "OL", style: "ordered-list-item" },
      { label: "Blockquote", style: "blockquote" },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: "Style", style: "unstyled" },
      { label: "Heading Large", style: "header-one" },
      { label: "Heading Medium", style: "header-two" },
      { label: "Heading Small", style: "header-three" },
    ],
  };
  const MAX_EDITOR_LENGTH = 2000;
  const handleEditorChange = (editorValue) => {
    // Get FULL HTML (unchanged)
    const editorHtml = editorValue.toString("html");

    // Optional: validate length INCLUDING HTML
    if (editorHtml && editorHtml.length > MAX_EDITOR_LENGTH) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorEditorMaxValue: true,
      }));
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorEditorMaxValue: false,
      }));
    }

    setEDITOR_CHAR_LENGTH(editorHtml.length);
    setEditorValue(editorValue);

    setState((prevState) => ({
      ...prevState,
      longDescription: editorHtml, // ✅ send full HTML
    }));
  };


  const Validate = (errorList) => {
    if (!state.name) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorName: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorName: false,
      }));
    }
    if (!state.bannerImg && bannerImage.fileToSend == null) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorBannerImg: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorBannerImg: false,
      }));
    }
    if (!state.fundedBy || state.fundedBy == '' || state.fundedBy == []) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorFundedBy: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorFundedBy: false,
      }));
    }


    if (!state.longDescription) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorDescription: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorDescription: false,
      }));
    }

  };

  const addGrantProgram = () => {
    let errorList = [];
    Validate(errorList);

    if (errorList.length < 1) {
      setIsLoading(true);
      const formData = new FormData();
      for (var key in state) {
        if (state[key] && key !== "fileToSend" && key !== "photoName" && key !== "encUserID") {
          formData.append(key, state[key]);
        }
      }

      formData.append("BannerFile", bannerImage.fileToSend);
      formData.append("DonorFile", donorImage.fileToSend);
      console.log(formData, "Add new oine by hassan");
      let apiEndpoint = "fdngrantprograms/add";
      if (editProgram) {
        apiEndpoint = "fdngrantprograms/update";
      }

      PostDataAPI(apiEndpoint, formData, true, "formData")
        .then((result) => {
          setIsLoading(false);
          if (result.success && result.data != null) {
            if (result.data) {
              handleSuccessClose("Address updated successfully.");
            } else {
              showMessage(
                "Error",
                "Error updating address, please contact administrator",
                "error",
                3000
              );
            }
          } else {
            showMessage("Error", result.message, "error", 3000);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          showMessage("Error", error.message, "error", 3000);
        });
    }
  };
  const handleMultiSelectChange = (name, selected) => {

    setState(prevState => ({
      ...prevState,
      [name]: selected
    }));
  };


  const [lstOrganization, setLstOrganization] = useState([{
    label: 'Choose Donor',
    value: ''
  }]);

  const loadOrganization = () => {
    PostDataAPI("fdngrantdonor/loadGrid").then((result) => {
      if (result.success && result.data) {

        setLstOrganization(prev => [
          ...prev,
          ...result.data.map(t => ({
            donorId: t.donorId,
            label: t.donorName,
            value: t.donorId
          }))
        ]);
      }
    })
  }
  useEffect(() => {
    loadOrganization()
    if (editProgram) {
      const newEditorValue = RichTextEditor.createValueFromString(state.longDescription, "html");
      setEditorValue(newEditorValue);
      setState(editProgram);
    }
  }, [editProgram]);

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      PaperComponent={DraggableComponent}
      disableBackdropClick
      disableEscapeKeyDown
      open={dialogOpenClose}
      maxWidth="lg"
      {...props}
    >
      <div className={classes.dialogContent}>
        <div className={classes.box}>
          <div className={classes.header} id="draggable-dialog-title">
            <Typography className={classes.title}>{state.programId > 0 ? 'Edit Program' : 'New Program'}</Typography>

            <Icon
              className={classes.closeIcon}
              onClick={handleClose}
              color="primary"
            >
              <CloseIcon />
            </Icon>
          </div>

          {isLoading ? <DialogLoader></DialogLoader> : ""}
          <Scrollbars autoHeight autoHeightMax={570}>
            <div className={classes.content}>
              <Grid container spacing={4}>
                <Grid item sm={12} md={12} lg={6} xl={6}>
                  <Label size={12} title="Program Name" mandatory={true} />
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <InputBaseField
                      id="name"
                      name="name"
                      type="text"
                      value={state.name}
                      onChange={handleChange}
                      placeholder="Program Name"
                      IsDisabled={false}
                      MaxLength={80}
                    />
                    {errorMessages.errorName && !state.name ? (
                      <FormHelperText style={{ color: "red" }}>
                        Please enter program name
                      </FormHelperText>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid container spacing={4}>
                <Grid item sm={12} md={12} lg={12} xl={12}>

                  <Label title="Description" size={12} mandatory={true} />
                  <RichTextEditor
                    id="longDescription"
                    name="longDescription"
                    type="text"
                    value={editorValue}
                    onChange={handleEditorChange}
                    className={classes.note}
                    placeholder="Short Description"
                    toolbarConfig={toolbarConfig}
                    IsDisabled={false}
                  ></RichTextEditor>

                  {errorMessages.errorDescription && !state.longDescription ? (
                    <FormHelperText style={{ color: "red" }}>
                      Please enter description
                    </FormHelperText>
                  ) : (
                    ""
                  )}


                </Grid>
              </Grid>

              <Grid container spacing={4}>
                <Grid item sm={12} md={12} lg={6} xl={6}>
                  <Label size={12} title="Add Image" mandatory={true} />
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <input
                      ref={inputFile}
                      id="bannerImg"
                      name="bannerImg"
                      type="file"
                      IsDisabled={false}
                      MaxLength={80}
                      style={{ display: "none" }}
                      onChange={uploadSingleFile}
                    />
                    <div className={classes.BrowseMain}>
                      <InputBaseField
                        type="text"
                        value={bannerImage.fileName ? bannerImage.fileName : state.bannerName}
                        placeholder="Image or Logo"
                        MaxLength={80}
                        className={classes.fileInput}

                        readOnly={true}
                        onPaste={(e) => e.preventDefault()}
                        onDrop={(e) => e.preventDefault()}
                      />
                      <a onClick={uploadFile} className={"BrowseButton"}>
                        Browse
                      </a>
                    </div>
                    {errorMessages.errorBannerImg && !state.bannerImg ? (
                      <FormHelperText style={{ color: "red" }}>
                        Please add Image
                      </FormHelperText>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>

                <Grid item sm={12} md={12} lg={6} xl={6}>
                  <Label size={12} title="Funded By" mandatory={true} />
                  <Grid container spacing={1}>
                    <Grid xs={11} sm={11} md={11} lg={11} xl={11}>
                      <SelectField
                        options={lstOrganization}
                        value={state.fundedBy}
                        onChange={handleChange}
                        id={'fundedBy'}
                        name={'fundedBy'}
                        placeholder='Funded By'
                        type="text"
                        label="Movie"
                      />
                      {errorMessages.errorFundedBy && !state.fundedBy ? (
                        <FormHelperText style={{ color: "red" }}>
                          Please Add Donor Name
                        </FormHelperText>
                      ) : (
                        ""
                      )}
                    </Grid>
                    {/* <Grid item xs={1} sm={1} md={1} lg={1} xl={1} className={classes.AddDonorIcon}>
                      <a>
                        <img src={addDonorIcon} alt="Add Donor Icon" />
                      </a>
                    </Grid> */}
                  </Grid>
                </Grid>
                <Grid item sm={12} md={12} lg={6} xl={6} >

                </Grid>
              </Grid>
            </div>
          </Scrollbars>
          <div className={classes.footer}>
            <div className={classes.footerRight}>
              <Button className={classes.backBtn} onClick={handleClose}>
                Close
              </Button>
              <Button className={classes.changeBtn} onClick={addGrantProgram}>
                {state.programId > 0 ? 'Update' : 'Add New'}
              </Button>
            </div>
          </div>
        </div>
      </div >
    </Dialog >
  );
}

export default withSnackbar(AddNewAddress);
